import { Client } from '@taruvi/sdk';
import { resolveApiUrl } from './resolveApiUrl.ts';

export const taruviClient = new Client({
  apiKey: import.meta.env.VITE_API_KEY,
  apiUrl: resolveApiUrl(),
  appSlug: import.meta.env.VITE_APP_SLUG,
});
